export default "/_next/static/chunks/fonts/Feather-0f5d9cede2e831f3fc80eac48fbb84f4.ttf";